import { ICategoryFilterState } from '../store/search/searchConditions';
import { WebCategory } from '../../../../domain/model/category/WebCategory';
export default class SearchHelper {
  /**
   * 検索ワードからYahoo!検索へのリンクURLを生成する
   *
   * @param query ユーザーが入力した生の検索ワード
   * @returns Yahoo!検索へのリンクURL
   */
  public static createYahooSearchUrl(query: string): string {
    return `https://search.yahoo.co.jp/search?p=${query}&ei=UTF-8`;
  }

  /**
   * カテゴリをオブジェクトからカンマ区切りの文字列に変換する
   *
   * @param categories カテゴリ毎にtrue/falseが設定されたオブジェクト
   * @returns カテゴリをカンマ区切りにした文字列
   */
  public static convertCategoryFilter(categories: ICategoryFilterState): string {
    const categoriesList = [];
    if (categories.domestic === true) {
      categoriesList.push(WebCategory.DOMESTIC);
    }
    if (categories.world === true) {
      categoriesList.push(WebCategory.WORLD);
    }
    if (categories.business === true) {
      categoriesList.push(WebCategory.BUSINESS);
    }
    if (categories.entertainment === true) {
      categoriesList.push(WebCategory.ENTERTAINMENT);
    }
    if (categories.sports === true) {
      categoriesList.push(WebCategory.SPORTS);
    }
    if (categories.it === true) {
      categoriesList.push(WebCategory.IT);
    }
    if (categories.science === true) {
      categoriesList.push(WebCategory.SCIENCE);
    }
    if (categories.life === true) {
      categoriesList.push(WebCategory.LIFE);
    }
    if (categories.local === true) {
      categoriesList.push(WebCategory.LOCAL);
    }
    return categoriesList.join(',');
  }

  // 引数の文字列の文頭・文末に三点リーダを付与する
  /**
   * @param targetText
   */
  public static add3PointLeader(targetText: string): string {
    let result = targetText;
    // 文頭がスペースではない場合は文頭に三点リーダ付与
    if (!result.match(/^[\s　]/)) {
      result = `…${result}`;
    }
    // 文末が。でない場合は文末に三点リーダ付与
    if (!result.match(/。$/)) {
      result = `${result}…`;
    }
    return result;
  }

  // ニュース検索のURLを生成する。パラメータのpとeiのみをつけて返す。
  /**
   * @param query
   */
  public static createNewsSearchUrl(query: string): string {
    return `/search?p=${encodeURIComponent(query)}&ei=utf-8`;
  }

  // クエリのエスケープ処理を行う
  public static escapeQuery = (query: string) => {
    const replaceMappings = [
      { input: /\\/g, output: '\\\\' },
      { input: /'/g, output: "\\'" },
      { input: /"/g, output: '\\"' },
      { input: /\r/g, output: '\\r' },
      { input: /\n/g, output: '\\n' },
      { input: /<\//g, output: '<\\/' }
    ];
    for (const obj of replaceMappings) {
      query = query.replace(obj.input, obj.output);
    }
    return query;
  };

  // 文字列の正規化を行う
  public static normalizeWord = (word: string) => {
    return (
      word
        .trimLeft()
        // スペースが連続しているところは一つのスペースにする
        .replace(/\s+/g, ' ')
    );
  };
}
